<div
  class="avatar {{ COLORS_MAP[color()] }} {{ SIZES_MAP[size()] }}"
  [class.avatar--circle]="shape() === 'circle'"
  [class.avatar--with-hover]="interactive()"
>
  <div class="avatar__inner df ai-c jc-c">
    @let avatar = avatarUrl();
    @let first = displayFirstName();
    @let last = displayLastName();
    @if ((!!last || !!first) && !avatar) {
      <span class="avatar__inner-name">
        {{ first | takeFirstLetter }}{{ last | takeFirstLetter }}
      </span>
    }

    @if (!!avatar) {
      <fr8bot-ui-image class="avatar__inner-img" [src]="avatar" alt="avatar" [size]="size()">
        <fr8bot-ui-icon preview name="avatar" [size]="size()" />
      </fr8bot-ui-image>
    }

    @if (!last && !first && !avatar) {
      <fr8bot-ui-icon name="avatar" [size]="size()" />
    }
  </div>
</div>
